import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/wh-support-docs/wh-support-docs/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import { Link } from "gatsby";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`Before you install or upgrade Cúram by Merative™ , review the supported operating systems, prerequisites and the supported software to ensure compatibility.`}</p>
    <p>{`A policy change has been implemented to the third-party prerequisites for Cúram version 7.0.0.0 and future versions of the product. Therefore, the prerequisites that are specified below now define support only for the third-party products for which the Cúram product has a direct dependency on. For more information about the policy change, see `}<a parentName="p" {...{
        "href": "https://www.merative.com/support/curam/news/social-program-management-third-party-prerequisites-policy-change"
      }}>{`here`}</a>{`.`}</p>
    <p>{`The minimum hardware requirements for Cúram by Merative™  development and test environments that were previously documented as part of the prerequisites are now documented in the Hardware requirements for `}<a parentName="p" {...{
        "href": "https://www.merative.com/support/curam/question-answer/hardware-requirements-for-development-and-test"
      }}>{`Cúram Social Program Management (SPM) Development and Test Environments tech note`}</a>{`.`}</p>
    <h2>{`8.2.2.0 Continuous Delivery`}</h2>
    <ul>
      <li parentName="ul">
        <Link to="/spm/prerequisites/822_java8" mdxType="Link">8.2.2.0 Java8 CD operating systems and supported software</Link>
      </li>
      <li parentName="ul">
        <Link to="/spm/prerequisites/822_modernjava" mdxType="Link">8.2.2.0 ModernJava CD operating systems and supported software</Link>
      </li>
    </ul>
    <h2>{`8.2.1.0 Continuous Delivery`}</h2>
    <ul>
      <li parentName="ul">
        <Link to="/spm/prerequisites/821_java8" mdxType="Link">8.2.1.0 Java8 CD operating systems and supported software</Link>
      </li>
      <li parentName="ul">
        <Link to="/spm/prerequisites/821_modernjava" mdxType="Link">8.2.1.0 ModernJava CD operating systems and supported software</Link>
      </li>
    </ul>
    <h2>{`8.2.0.0 Continuous Delivery & Long Term Support`}</h2>
    <ul>
      <li parentName="ul">
        <Link to="/spm/prerequisites/820_java8" mdxType="Link">8.2.0.0 Java8 CD operating systems and supported software</Link>
      </li>
      <li parentName="ul">
        <Link to="/spm/prerequisites/820_modernjava" mdxType="Link">8.2.0.0 ModernJava CD operating systems and supported software</Link>
      </li>
    </ul>
    <h2>{`8.1.3 Continuous Delivery`}</h2>
    <ul>
      <li parentName="ul">
        <Link to="/spm/prerequisites/813" mdxType="Link">8.1.3 CD operating systems and supported software</Link>
      </li>
    </ul>
    <h2>{`8.1.2 Continuous Delivery`}</h2>
    <ul>
      <li parentName="ul">
        <Link to="/spm/prerequisites/812" mdxType="Link">8.1.2 CD operating systems and supported software</Link>
      </li>
    </ul>
    <h2>{`8.1.1 Continuous Delivery`}</h2>
    <ul>
      <li parentName="ul">
        <Link to="/spm/prerequisites/811" mdxType="Link">8.1.1 CD operating systems and supported software</Link>
      </li>
    </ul>
    <h2>{`8.1 Continuous Delivery`}</h2>
    <ul>
      <li parentName="ul">
        <Link to="/spm/prerequisites/810" mdxType="Link">8.1 CD operating systems and supported software</Link>
      </li>
    </ul>
    <h2>{`8.0.3 Continuous Delivery`}</h2>
    <ul>
      <li parentName="ul">
        <Link to="/spm/prerequisites/803" mdxType="Link">8.0.3 CD operating systems and supported software</Link>
      </li>
    </ul>
    <h2>{`8.0.1.4 Long Term Support`}</h2>
    <ul>
      <li parentName="ul">
        <Link to="/spm/prerequisites/8014" mdxType="Link">8.0.1.4 LTS operating systems and supported software</Link>
      </li>
    </ul>
    <h2>{`8.0.1.1 Long Term Support`}</h2>
    <ul>
      <li parentName="ul">
        <Link to="/spm/prerequisites/8011" mdxType="Link">8.0.1.1 LTS operating systems and supported software</Link>
      </li>
    </ul>
    <h2>{`Cúram on Kubernetes`}</h2>
    <p>{`Additional prerequisites are needed to deploy Cúram on cloud native hosting platforms. For information about deploying Cúram on Kubernetes Services or Red Hat® OpenShift®, see the prerequisites in the Cúram Kubernetes Runbook.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://merative.github.io/curam-kubernetes/prereq/prereq/"
        }}>{`Cúram on Kubernetes prerequisites`}</a></li>
    </ul>
    <h2>{`Licence information`}</h2>
    <p>{`The details of the versions of IBM® products which are currently licensed to be used as a Supporting Program with Merative™ SPM Platform can be seen on the following page.`}</p>
    <ul>
      <li parentName="ul">
        <Link to="/spm/prerequisites/licensed-platform" mdxType="Link">Supporting Program versions for Merative™ SPM Platform</Link>
      </li>
    </ul>
    <h2>{`Merative Cúram Citizen Engagement assets`}</h2>
    <p>{`Prerequisites and compatibility with Cúram versions are detailed in the PDF documentation for the Merative SPM Universal Access Responsive Web Application and the Merative SPM Design System assets.`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "https://curam-spm-devops.github.io/wh-support-docs/spm/pdf-documentation#merative-spm-citizen-engagement"
          }}>{`Merative SPM Universal Access Responsive Web Application prerequisites`}</a></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "https://curam-spm-devops.github.io/wh-support-docs/spm/pdf-documentation#social-program-management-design-system-pdfs"
          }}>{`Merative SPM Social Program Management Design System prerequisites`}</a></p>
      </li>
    </ul>
    <h2>{`Previous versions`}</h2>
    <h3>{`8.0.1.0 LTS`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/8010CD-windows.pdf"
        }}>{`Windows operating systems 8.0.1.0 CD`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/8010CD-linux.pdf"
        }}>{`Linux operating systems 8.0.1.0 CD`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/8010CD-software.pdf"
        }}>{`Prerequisites and supported software 8.0.1.0 CD`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://merative.github.io/curam-kubernetes/prereq/prereq"
        }}>{`Cúram on Kubernetes prerequisites`}</a></li>
    </ul>
    <h3>{`8.0.0`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/8000-windows.pdf"
        }}>{`Windows operating systems 8.0.0`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/8000-linux.pdf"
        }}>{`Linux operating systems 8.0.0`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/8000-software.pdf"
        }}>{`Prerequisites and supported software 8.0.0`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://merative.github.io/curam-kubernetes/prereq/prereq"
        }}>{`Cúram on Kubernetes prerequisites`}</a></li>
    </ul>
    <h2>{`8.0.2.0 CD`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/8020CD-windows.pdf"
        }}>{`Windows operating systems 8.0.2.0 CD`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/8020CD-linux.pdf"
        }}>{`Linux operating systems 8.0.2.0 CD`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/8020CD-software.pdf"
        }}>{`Prerequisites and supported software 8.0.2.0 CD`}</a></li>
    </ul>
    <h3>{`7.0.11.0`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/70110RP-windows.pdf"
        }}>{`Windows operating systems 7.0.11.0 RP`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/70110RP-linux.pdf"
        }}>{`Linux operating systems 7.0.11.0 RP`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/70110RP-software.pdf"
        }}>{`Prerequisites and supported software 7.0.11.0 RP`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://merative.github.io/curam-kubernetes/prereq/prereq"
        }}>{`Cúram on Kubernetes prerequisites`}</a></li>
    </ul>
    <h3>{`7.0.10.0`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/70100-windows.pdf"
        }}>{`Windows operating systems 7.0.10.0`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/70100-linux.pdf"
        }}>{`Linux operating systems 7.0.10.0`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/70100-software.pdf"
        }}>{`Prerequisites and supported software 7.0.10.0`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://merative.github.io/curam-kubernetes/prereq/prereq"
        }}>{`Cúram on Kubernetes prerequisites`}</a></li>
    </ul>
    <h3>{`7.0.9.0`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/7090RP-windows.pdf"
        }}>{`Windows operating systems 7.0.9.0 RP`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/7090RP-linux.pdf"
        }}>{`Linux operating systems 7.0.9.0 RP`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/7090RP-software.pdf"
        }}>{`Prerequisites and supported software 7.0.9.0 RP`}</a></li>
    </ul>
    <h3>{`7.0.8.0`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/7080RP-windows.pdf"
        }}>{`Windows operating systems 7.0.8.0 RP`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/7080RP-linux.pdf"
        }}>{`Linux operating systems 7.0.8.0 RP`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/7080RP-software.pdf"
        }}>{`Prerequisites and supported software 7.0.8.0 RP`}</a></li>
    </ul>
    <h3>{`7.0.7.0`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/7070RP-windows.pdf"
        }}>{`Windows operating systems 7.0.7.0 RP`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/7070RP-linux.pdf"
        }}>{`Linux operating systems 7.0.7.0 RP`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/7070RP-software.pdf"
        }}>{`Prerequisites and supported software 7.0.7.0 RP`}</a></li>
    </ul>
    <h3>{`7.0.6.0`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/7060RP-windows.pdf"
        }}>{`Windows operating systems 7.0.6.0 RP`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/7060RP-linux.pdf"
        }}>{`Linux operating systems 7.0.6.0 RP`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/7060RP-software.pdf"
        }}>{`Prerequisites and supported software 7.0.6.0 RP`}</a></li>
    </ul>
    <h3>{`7.0.5.0`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/7050-windows.pdf"
        }}>{`Windows operating systems 7.0.5.0`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/7050-linux.pdf"
        }}>{`Linux operating systems 7.0.5.0`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/7050-software.pdf"
        }}>{`Prerequisites and supported software 7.0.5.0`}</a></li>
    </ul>
    <h3>{`7.0.4.4`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/7044-windows.pdf"
        }}>{`Windows operating systems 7.0.4.4`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/7044-linux.pdf"
        }}>{`Linux operating systems 7.0.4.4`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/7044-software.pdf"
        }}>{`Prerequisites and supported software 7.0.4.4`}</a></li>
    </ul>
    <h3>{`7.0.4.3`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/7043-windows.pdf"
        }}>{`Windows operating systems 7.0.4.3`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/7043-linux.pdf"
        }}>{`Linux operating systems 7.0.4.3`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/7043-software.pdf"
        }}>{`Prerequisites and supported software 7.0.4.3`}</a></li>
    </ul>
    <h3>{`7.0.4.2`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/7042-windows.pdf"
        }}>{`Windows operating systems 7.0.4.2`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/7042-linux.pdf"
        }}>{`Linux operating systems 7.0.4.2`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/7042-software.pdf"
        }}>{`Prerequisites and supported software 7.0.4.2`}</a></li>
    </ul>
    <h3>{`7.0.4.1`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/7041-windows.pdf"
        }}>{`Windows operating systems 7.0.4.1`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/7041-linux.pdf"
        }}>{`Linux operating systems 7.0.4.1`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/7041-software.pdf"
        }}>{`Prerequisites and supported software 7.0.4.1`}</a></li>
    </ul>
    <h3>{`7.0.4.0`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/7040RP-windows.pdf"
        }}>{`Windows operating systems 7.0.4.0 RP`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/7040RP-linux.pdf"
        }}>{`Linux operating systems 7.0.4.0 RP`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/7040RP-software.pdf"
        }}>{`Prerequisites and supported software 7.0.4.0 RP`}</a></li>
    </ul>
    <h3>{`7.0.3.0`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/7030RP-windows.pdf"
        }}>{`Windows operating systems 7.0.3.0 RP`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/7030RP-linux.pdf"
        }}>{`Linux operating systems 7.0.3.0 RP`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/7030RP-software.pdf"
        }}>{`Prerequisites and supported software 7.0.3.0 RP`}</a></li>
    </ul>
    <h3>{`7.0.2.1`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/7021-windows.pdf"
        }}>{`Windows operating systems 7.0.2.1`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/7021-linux.pdf"
        }}>{`Linux operating systems 7.0.2.1`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/7021-software.pdf"
        }}>{`Prerequisites and supported software 7.0.2.1`}</a></li>
    </ul>
    <h3>{`7.0.2.0`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/7020-windows.pdf"
        }}>{`Windows operating systems 7.0.2.0`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/7020-linux.pdf"
        }}>{`Linux operating systems 7.0.2.0`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/7020-software.pdf"
        }}>{`Prerequisites and supported software 7.0.2.0`}</a></li>
    </ul>
    <h3>{`7.0.1.3`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/7013-windows.pdf"
        }}>{`Windows operating systems 7.0.1.3`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/7013-linux.pdf"
        }}>{`Linux operating systems 7.0.1.3`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/7013-software.pdf"
        }}>{`Prerequisites and supported software 7.0.1.3`}</a></li>
    </ul>
    <h3>{`7.0.1.2`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/7012-windows.pdf"
        }}>{`Windows operating systems 7.0.1.2`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/7012-linux.pdf"
        }}>{`Linux operating systems 7.0.1.2`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/7012-software.pdf"
        }}>{`Prerequisites and supported software 7.0.1.2`}</a></li>
    </ul>
    <h3>{`7.0.1.1`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/7011-windows.pdf"
        }}>{`Windows operating systems 7.0.1.1`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/7011-linux.pdf"
        }}>{`Linux operating systems 7.0.1.1`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/7011-software.pdf"
        }}>{`Prerequisites and supported software 7.0.1.1`}</a></li>
    </ul>
    <h3>{`7.0.1.0`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/7010-windows.pdf"
        }}>{`Windows operating systems 7.0.1.0`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/7010-linux.pdf"
        }}>{`Linux operating systems 7.0.1.0`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/7010-software.pdf"
        }}>{`Prerequisites and supported software 7.0.1.0`}</a></li>
    </ul>
    <h3>{`7.0.0.2`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/7002-windows.pdf"
        }}>{`Windows operating systems 7.0.0.2`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/7002-linux.pdf"
        }}>{`Linux operating systems 7.0.0.2`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/7002-software.pdf"
        }}>{`Prerequisites and supported software 7.0.0.2`}</a></li>
    </ul>
    <h3>{`7.0.0.1`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/7001-windows.pdf"
        }}>{`Windows operating systems 7.0.0.1`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/7001-linux.pdf"
        }}>{`Linux operating systems 7.0.0.1`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/7001-software.pdf"
        }}>{`Prerequisites and supported software 7.0.0.1`}</a></li>
    </ul>
    <h3>{`7.0.0`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/7000-windows.pdf"
        }}>{`Windows operating systems 7.0.0`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/7000-linux.pdf"
        }}>{`Linux operating systems 7.0.0`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/prereqs/7000-software.pdf"
        }}>{`Prerequisites and supported software 7.0.0`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      